import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { LoginService, UserProfileService, ProductRouteInfoService, RaService } from '../../../../core';
import { Subscription, Subject, Observable } from 'rxjs';

@Component({
  selector: 'app-qa-select-company',
  templateUrl: './qa-select-company.component.html',
  styleUrls: ['./qa-select-company.component.scss']
})
export class QaSelectCompanyComponent implements OnInit {
  public errors: string[] = [];
  public filteredAccountNameList: Array<string> = [];
  public filteredAccountName;
  contractYearList: Array<number> = [];
  public contractYearDropdownPopupSettings = { height: 80 };
  public rfpAccountsDropdownPopupSettings = { width: 250 };
  public date: Date;
  public showAccountdropdown: boolean = true;
  public selectedContractYear: number;
  rfpAccountList: Array<{ channelID: number, clientID: number, customerNumber: string, name: string, type: string, isTest: boolean }> = [];

  @Input() isQuickAuditRerun:boolean = false;
  @Output() RfpAccountChange = new EventEmitter<number>();

  _rfpAccountid:number;
  set  rfpAccountid(val: number){
    this._rfpAccountid = val;
    this.RfpAccountChange.next(val) ;
  };
  get rfpAccountid():number{
    return this._rfpAccountid;
  }

  constructor(
    private loginService: LoginService,
    private userProfileService: UserProfileService,
    private raService: RaService
  ) {
  }

  ngOnInit() {
    this.date = new Date();
    this.contractYearList.push( this.date.getFullYear() - 1);
    this.contractYearList.push( this.date.getFullYear() );
    this.contractYearList.push( this.date.getFullYear() + 1);
    if (!this.isQuickAuditRerun) {
      this.selectedContractYear = this.contractYearList[1];
      let user = this.userProfileService.data;
      if ( user.CustomerType == "Corporation" || user.CustomerType == "Consortia Advanced") {
        this.showAccountdropdown = false;
      }

      if (this.showAccountdropdown) {
       this.GetRFPAccounts();
      }

    }
  }

  OnRfpAccountsChanged(value) {
    this.rfpAccountid = value.channelID;
  }

  OnContractYearChanged(value: any) {
    if (value)
      this.selectedContractYear = value;
    if (this.showAccountdropdown) {
     this.GetRFPAccounts();
    }
  }
  GetRFPAccounts() {
    this.raService.getRFPAccounts(this.selectedContractYear)
      .subscribe(r => {
        this.rfpAccountList = r.map(item => {
          return {
            name: item.name,
            channelID: item.channelID,
            clientID: item.clientID,
            customerNumber: item.customerNumber,
            type: item.type,
            isTest: item.isTest
          };
        }).sort((a, b) => {
          return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });

      }, (err) => { console.log(err) },
        () => {
          if (this.rfpAccountList.length > 0) {
            this.rfpAccountid = this.rfpAccountList[0].channelID;
/*             var dd = this.rfpAccountList.find( r => r.name =="Philip Exchangee");
            if(dd)
              this.rfpAccountid = dd.channelID;
 */
          }
        }
      );
  }
}
